export class OptimizerResultsState {
  static WORSE = 0;
  static THE_SAME = 1;
  static BETTER = 2;
}
